import { type FC, type PropsWithChildren } from 'react';
import * as Sentry from '@sentry/react';

import { env } from '@/config/env';

const allowedEnv = ['staging', 'production'] as const;

export const SentryWrapper: FC<PropsWithChildren> = ({ children }) => {
  const isSentryEnabled = !!env.sentryDsn && allowedEnv.includes(env.appEnv);

  if (!isSentryEnabled) {
    return <>{children}</>;
  }

  return (
    <Sentry.ErrorBoundary fallback={<div>Oops, something went wrong.</div>}>
      {children}
    </Sentry.ErrorBoundary>
  );
};
